module.exports = __webpack_public_path__ + "4a74738e7728e93c4394b8604081da62.woff2";